// extracted by mini-css-extract-plugin
module.exports = {"container":"EventMemberItem_container__3TqV-"};